import React, { useEffect, useState } from 'react';
import { Check, ChevronsUpDown, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from '@/components/ui/command';
import { searchSorts } from '@/services/tissueJwApi';

// Sort No typeahead: shows the FG mapped in the Sort No master + free pieces in Greige Storage.
export const SortPicker = ({ value, onPick, testId }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    setLoading(true);
    const t = setTimeout(() => searchSorts(q).then((r) => setRows(r.sorts || [])).catch(() => setRows([]))
      .finally(() => setLoading(false)), 250);
    return () => clearTimeout(t);
  }, [q, open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="w-full justify-between font-normal" data-testid={testId}>
          <span className={value ? 'font-mono' : 'text-gray-400'}>{value?.sort_no || 'Pick sort no…'}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[360px]" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Type a sort no…" value={q} onValueChange={setQ} data-testid={`${testId}-search`} />
          <CommandList>
            {loading && <div className="py-4 flex justify-center"><Loader2 className="w-4 h-4 animate-spin" /></div>}
            {!loading && <CommandEmpty>No sort with an FG found</CommandEmpty>}
            {!loading && rows.map((s) => (
              <CommandItem key={s.sort_no} value={s.sort_no} onSelect={() => { onPick(s); setOpen(false); }}
                data-testid={`sort-option-${s.sort_no}`}>
                <Check className={`w-4 h-4 mr-2 ${value?.sort_no === s.sort_no ? 'opacity-100' : 'opacity-0'}`} />
                <div className="min-w-0">
                  <p className="font-mono text-sm">{s.sort_no} <span className="text-gray-400">→</span> {s.fg_name}</p>
                  <p className="text-[11px] text-gray-500 truncate">{s.design_name} {s.shade && `· ${s.shade}`} · {s.free_pcs} pcs free ({s.free_bundles} bundles)</p>
                </div>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SortPicker;
